<template>
  <b-modal v-model="isShow" @hide="onClose">
    <template #modal-title>
      {{ title }}
    </template>
    <b-container fluid>
      <b-row class="mb-1">
        <b-col>{{ message }}</b-col>
      </b-row>
    </b-container>
    <template #modal-footer="{ ok }">
      <div class="w-100">
        <div class="float-right">
          <b-button variant="danger" size="sm" @click="resendEmail">
            {{ $t('Resend Verification Email') }}
          </b-button>
          <b-button variant="primary" size="sm" @click="ok">
            {{ $t('Close') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { firebaseAuth } from '@/libs/firebase'

export default {
  name: 'EmailVerificationPopup',
  data() {
    return {
      title: '',
      message: '',
      user: {},
      isShow: false
    }
  },
  computed: {
    ...mapState(['emailVerificationPopupData'])
  },
  methods: {
    ...mapMutations(['setMessagePopupData']),
    async resendEmail() {
      await firebaseAuth.resendVerification()
      this.setMessagePopupData({
        title: this.$t('Login Email verification'),
        message: this.$t(
          'Check your Email Verification, Verification Email takes few minutes.'
        ),
        isShow: true
      })
      this.isShow = false
    },
    async onClose() {
      await firebaseAuth.logout()
      this.isShow = false
    }
  },
  watch: {
    emailVerificationPopupData() {
      if (this.emailVerificationPopupData.isShow) {
        this.title = this.emailVerificationPopupData.title
        this.message = this.emailVerificationPopupData.message
        this.user = this.emailVerificationPopupData.user
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style scoped>
button.btn-danger {
  margin-right: 10px;
}
</style>
